import React, {useEffect, useState} from "react";
import API from "../api/api";
import "./health.css"

const Health = () => {
    const api = API()
    const [health, setHealth] = useState('not tested')

    const getHealth = async (promise) => {
        setHealth("checking...")
        const response = await api.health()
        setHealth(response.ok ? "OK" : response.statusText || "error")
    }

    useEffect(() => {
        getHealth()
        },[]
    )

    return <span className={"health"} onClick={getHealth}>health: {health}</span>
}

export default Health